import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import { colors } from '../../../constants/colors';
import TrashIcon from '../icons/TrashIcon';
import sizes from './sizes';
const DeleteButton = ({ color, disabled, onClick, title, id, className, size, dataTestId, }) => {
    return (React.createElement(CircleButton, { id: id, size: size, className: className, color: color, disabled: disabled, onClick: onClick, title: title, dataTestId: dataTestId || "deleteButton" },
        React.createElement(TrashIcon, null)));
};
DeleteButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    color: PropTypes.oneOf(Object.values(colors)),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string,
};
DeleteButton.defaultProps = {
    size: sizes.normal,
    color: colors.red,
    disabled: false,
    title: '',
    onClick: () => { },
};
export default DeleteButton;
